/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// biome-ignore-all lint: auto-generated code
// deno-lint-ignore-file

/** The access roles and/or permissions to check */
export type AccessChecks = string[];
export type AccessResponseItem = Record<string, boolean>;

export type BadRequestError = {
  code: string;
  message: string;
};

export type GetMemberRolesByWorkspaceResponse = {
  orgRole: OrgRole;
  productRoles: ProductRoleFull[];
  ssoGroups: string[];
  workspaceRole: WorkspaceRoleFull;
};

/** Represents a response object of items, containing a list of members */
export type GetOrganizationMembersResponse = {
  count: number;
  items: Member[];
};

export type InternalServerError = {
  code: string;
  message: string;
};

/** Represents a member in the system */
export type Member = {
  /**
   * The email address of the member
   * @format email
   */
  email: string;
  /** The family name of the member */
  familyName: string;
  /** The given name of the member */
  givenName: string;
  /** If user is SSO */
  isSso?: boolean;
  /** The first and last name of the member */
  name?: string;
  /**
   * The URL of the member's picture
   * @format uri
   */
  picture?: string;
  roles: {orgRole?: OrgRole; productRoles?: ProductRoleFull[]; workspaceRoles?: WorkspaceRoleFull[]};
  /** Account active status */
  status?: string;
  /** The user ID of the member */
  userId: string;
};

export type MemberAccessCheckProduct = {
  checks?: AccessChecks;
  productName: string;
};

export type MemberAccessCheckRequest = MemberAccessCheckRequestItem[] | MemberAccessCheckRequestItem;

export type MemberAccessCheckRequestItem =
  | {
      accessType: MemberAccessCheckType;
      checks?: AccessChecks;
      products?: MemberAccessCheckProduct[];
      workspaceId?: string;
    }
  | {
      accessType: MemberAccessCheckType;
      checks?: AccessChecks;
      products?: MemberAccessCheckProduct[];
      workspaceId: string;
    }
  | {
      accessType: MemberAccessCheckType;
      checks?: AccessChecks;
      products: MemberAccessCheckProduct[];
      workspaceId: string;
    };

export type MemberAccessCheckResponse = {
  organization?: AccessResponseItem;
  /** Organization Identifier */
  organizationId?: string;
  /** User Identifier */
  userId?: string;
  workspaces?: Workspaces;
};

/** Which level of access to check (organization, workspace). Products are under workspace. */
export enum MemberAccessCheckType {
  Organization = 'organization',
  Workspace = 'workspace',
  Product = 'product',
  System = 'system',
}

/** An organization role that can be assigned to a member */
export type OrgRole = {};

/** A product role that can be assigned to a member */
export type ProductRoleFull = {
  product?: string;
  role?: string;
  workspaceName?: string;
};

export type ServiceUnavailableError = {
  code: string;
  message: string;
};

export type WorkspaceAccess = {
  products?: {[key: string]: AccessResponseItem};
  [key: string]: boolean | {[key: string]: AccessResponseItem} | undefined;
};
/** A workspace role that can be assigned to a member */
export type WorkspaceRoleFull = {
  role?: string;
  workspaceName?: string;
};

export type Workspaces = Record<string, WorkspaceAccess>;
